<template id="backToTop">
  <div id="imagecont" :class="generalBackground">
    <div style="height: 70px;"></div>
    <b-container v-show="picvisible">
      <!-- <b-container class="backrow bv-example-row bv-example-row-flex-cols"  :style="{ background: 'url(' + backRowStyle + ')'+' center / cover no-repeat' }"> -->
      <b-container :class="backRowStyle" class="bv-example-row bv-example-row-flex-cols">
        <!-- <b-container class="backrow bv-example-row bv-example-row-flex-cols" :style="backRowStyle"> -->
        <b-row class="titlepos align-items-center" :class="textVendor">
          <b-col class="mt-5" align-self="center">
            <div v-if="sharedLogoUrl" class="header-logo mb-3">
              <img :src="sharedLogoUrl" alt="Vendor logo" />
            </div>

            <div class="headline-text">
              Drive now, Pay Later !
            </div>
          </b-col>
        </b-row>
      </b-container>
      <!-- <b-container class="bv-example-row">
        <b-row cols="12" class="buttonloc justify-content-md-center">
          <b-col col lg="4">
            <b-button
              block
              size="lg"
              class="buttontextsize"
              style="height: 70px; font-weight: bold;"
              :class="[isActive ? 'red' : 'blue']"
              @click="toggleClass()"
              >Enter Make / Model</b-button
            >
          </b-col>
          <b-col col lg="4">
            <b-button
              block
              size="lg"
              class="buttontextsize"
              style="height: 70px; font-weight: bold;"
              :class="[isActive ? 'blue' : 'red']"
              @click="toggleClassTwo()"
              >Enter VIN</b-button
            >
          </b-col>
        </b-row>
      </b-container> -->
      <b-container class="mt-4">
        <!-- LOCATION PICKER -->
        <b-row v-if="showLocationPicker" class="justify-content-md-center">
          <b-col cols="12" md="8" lg="6">
            <b-card class="location-card" body-class="p-4">
              <div class="text-center mb-3">
                <div class="location-kicker">Almost there</div>
                <h4 class="mb-1">Select your location</h4>
                <p class="text-muted mb-0">Choose where you're getting service.</p>
              </div>

              <b-list-group flush>
                <b-list-group-item
                  v-for="v in vendorChoices"
                  :key="v.id"
                  class="location-item d-flex align-items-center justify-content-between"
                  button
                  @click="selectVendor(v.id)"
                >
                  <div class="text-left">
                    <div class="location-name">{{ v.label }}</div>
                    <div class="location-sub">{{ v.sub || '' }}</div>
                  </div>

                  <b-button size="sm" variant="primary" class="location-cta">
                    Select
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-col>
        </b-row>

        <!-- NORMAL FLOW -->
        <div v-else>
          <div
            v-if="vendorChoices.length > 1"
            class="d-flex justify-content-between align-items-center mb-3"
          >
            <div class="location-pill">Location: {{ selectedVendorLabel }}</div>
            <b-button size="sm" variant="link" class="p-0" @click="changeLocation">
              Change
            </b-button>
          </div>

          <VandM :message="isActive"></VandM>
        </div>
      </b-container>
    </b-container>
    <transition name="fade">
      <div v-if="visible" class="vue-back-to-top">
        <VandM :message="msg" />
      </div>
    </transition>
  </div>
</template>

<script>
import $ from 'jquery'
import logoMap from '@/assets/logos'

export default {
  name: 'Main',
  props: {
    text: {
      type: String,
      default: 'text',
    },
    visibleoffset: {
      type: [String, Number],
      default: 600,
    },
    left: {
      type: String,
      default: '0px',
    },
    bottom: {
      type: String,
      default: '0px',
    },
  },
  data() {
    return {
      msg: 'i did it',
      showCreditCard: true,
      buttontoggler: 'primary',
      opbuttontoggler: 'outline-primary',
      myToggle: false,
      isActive: false,
      visible: false,
      picvisible: true,
      textone: 'omer',
      showstar: false,
      mycolor: '0E78E1',
      parameters: '',
      image:
        'http://1.bp.blogspot.com/-8PfnHfgrH4I/TylX2v8pTMI/AAAAAAAAJJ4/TICBoSEI57o/s1600/search_by_image_image.png',
      appData: {
        backgroundObject: 'backwidg.png',
        backgroundObjectGrizzly: 'grizzly.png',
      },
      showLocationPicker: false,
      vendorChoices: [],
      selectedVendorId: null,
      sharedLogoUrl: '',
    }
  },
  computed: {
    effectiveVendor() {
      return (
        this.selectedVendorId ||
        this.$store.state.userData.selectedVendor ||
        this.$route.query.vendor
      )
    },

    selectedVendorLabel() {
      const found = this.vendorChoices.find(v => v.id === this.selectedVendorId)
      return found && found.label ? found.label : 'Selected location'
    },

    backRowStyle() {
      const v = this.effectiveVendor
      if (v === '619d60ac3ddfde0bc5120f14') return 'backrowGrizzly'
      return 'backrow'
    },

    generalBackground() {
      const v = this.effectiveVendor
      if (v === '619d60ac3ddfde0bc5120f14') return 'grizzlyBackground'
      return 'generalBackground'
    },

    textVendor() {
      const v = this.effectiveVendor
      if (v === '619d60ac3ddfde0bc5120f14') return 'grizzlyText'
      return 'generalText'
    },
  },

  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search)

    const vendorParam = urlParams.get('vendor') || ''
    console.log('vendorParam:', vendorParam)
    const labelsParam = urlParams.get('vendorLabels') || ''

    const vendorIds = vendorParam
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
    const vendorLabels = labelsParam
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)

    const productDescription = urlParams.get('productDescription')
    const price = urlParams.get('price')
    const logoParam = urlParams.get('logo') || ''
    this.$store.state.userData.selectedProduct = productDescription
    this.$store.state.userData.productPrice = price
    this.$store.state.userData.repairOfferAmount = price
    this.sharedLogoUrl = logoMap[logoParam] || ''

    if (vendorIds.length === 0) {
      this.$store.state.userData.selectedVendor = '5e595abe5f786369a72bfd3f'
      return
    }

    if (vendorIds.length === 1) {
      this.selectedVendorId = vendorIds[0]
      this.$store.state.userData.selectedVendor = vendorIds[0]

      // optional: store for UI
      this.vendorChoices = [
        {
          id: vendorIds[0],
          label: vendorLabels[0] || 'Location',
          sub: '',
          logo: this.sharedLogoUrl,
        },
      ]
      return
    }

    this.vendorChoices = vendorIds.map((id, i) => ({
      id: id,
      label: vendorLabels[i] || `Location ${i + 1}`,
      sub: '',
      logo: this.sharedLogoUrl,
    }))

    this.showLocationPicker = true
  },
  async mounted() {
        const urlParams = new URLSearchParams(window.location.search)

        const vendorParam = urlParams.get('vendor') || ''
    const vendorIds = vendorParam
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
    try {
      const vendors = await this.$store.dispatch('fetchVendorsById', vendorIds)

      this.vendorChoices = vendors.map(v => ({
        id: v.id || v._id, // depending on what your endpoint returns
        label: v.name || v.username, // depending on payload
        sub: v.address || '',
      }))
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    selectVendor(id) {
      this.selectedVendorId = id
      this.$store.state.userData.selectedVendor = id
      this.showLocationPicker = false
    },

    changeLocation() {
      if (this.vendorChoices.length > 1) {
        this.showLocationPicker = true
      }
    },
    toggleClass() {
      console.log(this.$store.state.userData.step)
      if (this.$store.state.userData.step > 1) {
        this.$store.state.userData.step = 0
        location.reload()
      } else {
        if ((this.isActive = true)) this.isActive = !this.isActive
      }
    },
    toggleClassTwo() {
      console.log(this.$store.state.userData.step)
      if (this.$store.state.userData.step > 1) {
        this.$store.state.userData.step = 0
        location.reload()
      } else {
        if ((this.isActive = false)) console.log(this.isActive)
        this.isActive = !this.isActive
      }
    },
    onpicOne() {
      if ('parentIFrame' in window) window.parentIFrame.size(560)
      return false
    },
    onpicTwo() {
      return [(this.visible = true), (this.picvisible = false)]
    },
  },
  template: '#backToTop',
}
</script>
<style scoped media="screen">
@import url('https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@1,900&display=swap');
.header-logo {
  width: 276px;
  height: 150px;
  margin: 0 auto;
  border-radius: 18px;
  overflow: hidden;
  background: transparent;
  border: none;
  box-shadow: none;
}

.header-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Keeps headline spacing consistent */
.headline-text {
  line-height: 1.1;
}

.location-card {
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.08);
}

.location-kicker {
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6c757d;
  font-weight: 700;
}

.location-item {
  border-radius: 14px !important;
  margin-bottom: 10px;
  padding: 14px 16px;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  transition: transform 0.08s ease, box-shadow 0.08s ease;
}

.location-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.08);
}

.location-name {
  font-weight: 800;
  font-size: 15px;
  color: #2f2f2f;
}

.location-sub {
  font-size: 12px;
  color: #6c757d;
}

.location-pill {
  background: #f3f6ff;
  border: 1px solid #dbe4ff;
  color: #2b3a67;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 13px;
}

.location-cta {
  border-radius: 999px;
  padding-left: 14px;
  padding-right: 14px;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}

.align-items-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap');

@media screen and (min-width: 1501px) {
  .titlepos {
    font-size: 2vw;
  }
}

@media screen and (min-width: 1001px) and (max-width: 1500px) {
  .titlepos {
    font-size: 3.5vw;
  }
}

@media screen and (min-width: 401px) and (max-width: 1000px) {
  .titlepos {
    font-size: 5vw;
  }
}

@media screen and (max-width: 400px) {
  .titlepos {
    font-size: 7vw;
  }
}

@media screen and (min-width: 1001px) and (max-width: 1500px) {
  .buttontextsize {
    font-size: 2vw;
  }
}

@media screen and (min-width: 701px) and (max-width: 1000px) {
  .buttontextsize {
    font-size: 2.5vw;
  }
}

@media screen and (min-width: 401px) and (max-width: 700px) {
  .buttontextsize {
    font-size: 3vw;
  }
}

@media screen and (max-width: 400px) {
  .buttontextsize {
    font-size: 4vw;
  }
}

.titlepos {
  position: absolute;
  margin-left: 0px;
  margin-right: 0px;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 250px;
  color: black;
  font-family: 'Inter Tight', sans-serif;
  color: #3b3b3b;
}
.red {
  border-color: #109de7;
  background: white;
  color: black;
}

.blue {
  background-color: #109de7;
  border-color: #109de7;
}

.am-active {
  background-color: rgb(21, 79, 202);
  color: white;
}

.am-not-active {
  background-color: white;
}

.alignit {
  text-align: center;
  border: 3px solid green;
}

.buttonvin {
  background-color: white;
}

.buttonmake {
  background-color: #109de7;
}

.backrow {
  background: url('../assets/images/backwidg.png') center / cover no-repeat;
  width: 100%;
  height: 300px;
  object-fit: cover;
  position: relative;
}

.backrowGrizzly {
  background: url('../assets/images/grizzly.png') center / cover no-repeat;
  width: 100%;
  height: 300px;
  object-fit: cover;
  position: relative;
}

.testdiv {
  background: url('../assets/images/backwidg.png') center / cover no-repeat;
}

.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
}

.buttonloc {
  margin-top: -20px;
}

.generalBackground {
  background-color: white;
}

.grizzlyBackground {
  background: url('../assets/images/backgroundCarParts.png');
  background-repeat: repeat;
}

.generalText {
  color: black;
}

.grizzlyText {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue